import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/bootstrap-datepicker.css";
import "./assets/css/fontawesome-all.css";
import "./assets/css/animate.min.css";

import "./assets/scss/style.scss";

import "bootstrap";

// import "./assets/js/bootstrap-datepicker.min.js";
// import "./assets/js/jquery.validate.min.js";

import "./assets/js/main.js";

const app = (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

function showGlobalError(message) {
  const root = document.getElementById("root");
  root.innerHTML =
    '<div style="padding:2rem;font-family:sans-serif">' +
    '<h2 style="color:#c00">Something went wrong</h2>' +
    '<p style="color:#555">Please share this with support:</p>' +
    '<pre style="background:#f8f8f8;border:1px solid #ddd;border-radius:4px;padding:1rem;font-size:12px;white-space:pre-wrap;word-break:break-word;color:#333">' +
    message +
    "\n\nUser Agent: " + navigator.userAgent +
    "\n\nURL: " + window.location.href +
    "</pre>" +
    '<button onclick="window.location.reload()" style="margin-top:1rem;padding:0.6rem 1.4rem;background:#f58220;color:#fff;border:none;border-radius:4px;font-size:15px;cursor:pointer">Try Again</button>' +
    "</div>";
}

window.onerror = function (message, source, line, col, error) {
  showGlobalError((error ? error.toString() : message) + "\n\nat " + source + ":" + line + ":" + col);
  return true;
};

window.onunhandledrejection = function (event) {
  showGlobalError(event.reason ? event.reason.toString() : "Unhandled promise rejection");
};

ReactDOM.render(app, document.getElementById("root"));
serviceWorker.unregister();
